export const brands = [
  { id: 1, img: "Assets/Sponsors/cub8-modified.png" },
  { id: 2, img: "Assets/Sponsors/tvslogo.png" },
  { id: 3, img: "Assets/Sponsors/ongc.png" },
  { id: 4, img: "Assets/Sponsors/nextgen.png" },
  { id: 5, img: "Assets/Sponsors/ktm.png" },
  { id: 6, img: "Assets/Sponsors/sara.png" },
  { id: 7, img: "Assets/Sponsors/fuel.png" },
  { id: 8, img: "Assets/Sponsors/urban.png" },
  { id: 9, img: "Assets/Sponsors/ss.png" },
  { id: 10, img: "Assets/Sponsors/belgum9.png" },
  { id: 11, img: "Assets/Sponsors/sm.png" },
  { id: 12, img: "Assets/Sponsors/es.png" },
  { id: 13, img: "Assets/Sponsors/lw14.jpg" },
  { id: 13, img: "Assets/Sponsors/leb.png" },
  { id: 13, img: "Assets/Sponsors/mrs.png" },
];

//images to Tshirt component
export const Tshirt = {
  Back: "./Assets/tshirt/frontimg1.png", 
  Front: "./Assets/tshirt/backimg.png", 
  background: "./Assets/bg/tbg.jpeg", 
};



export const slides = [
  {
    img: "Assets/bg/bg-2.jpeg",
    title: "THETA",
    topic: "2K25",
    des: "FUSION of ideas, FUN-filled experiences, and a grand FIESTA of celebration.",
    buttons: ["SEE MORE"],
    thumbnailtitle: "",
    thumbnaildesc: "",
    path: "/Workshops",
  },
  {
    img: "Assets/bg/bg-4.png",
    title: "Theta Day 1",
    topic: "Team Swaraag",
    des: "Musical Fusion : Unleash the Rhythm with Our Music Teams",
    buttons: ["SEE MORE"],
    thumbnailtitle: "Day 1",
    thumbnaildesc: "",
    path: "/day-one",
  },
  {
    img: "Assets/bg/bg-2.png",
    title: "Theta Day 2",
    topic: "Team Recoil",
    des: "Recoil in Action : Feel the Energy with Team Recoil's Electrifying Performance",
    buttons: ["SEE MORE"],
    thumbnailtitle: "Day 2",
    thumbnaildesc: " ",
    path: "/day-two",
  },
  {
    img: "Assets/bg/finaloutlove.jpg",
    title: "Theta Day 3",
    topic: "By Onelove",
    des: "",
    buttons: ["SEE MORE"],
    thumbnailtitle: "Day 3",
    thumbnaildesc: "",
    path: "/day-three",
  },
];
export const aboutTheta = {
  title: "About Theta",
  description:
    "Theta is a grand fusion of ideas, fun-filled experiences, and celebrations. Join us to witness an electrifying lineup of events and workshops designed to inspire and entertain!",
  image: "../Assets/bg/clg.jpg", // Adjust the path if needed
  brochureLink: "../Assets/theta.pdf",
  buttonText: "Download Brochure",
};

export const reviews = [
  {
    id: 1,
    avatar: "https://randomuser.me/api/portraits/men/1.jpg",
    name: "",
    role: "-Student",
    review:
      "Theta is an amazing platform! The workshops are informative and fun! 🎉 I always leave feeling inspired.",
  },
  {
    id: 2,
    avatar: "https://randomuser.me/api/portraits/women/2.jpg",
    name: "",
    role: "-Event Organizer",
    review:
      "The DJ events are electrifying! Can't wait for the next one! 🎶 Every performance is better than the last!",
  },
  {
    id: 3,
    avatar: "https://randomuser.me/api/portraits/men/3.jpg",
    name: "",
    role: "-Student",
    review:
      "The variety of workshops offered is impressive! I learned so much! It's a great way to meet new people too.",
  },
  {
    id: 4,
    avatar: "https://randomuser.me/api/portraits/women/4.jpg",
    name: "",
    role: "-Art Student",
    review:
      "A fantastic experience! The events help us connect and express our creativity. I’ve made lifelong friends here.",
  },
  {
    id: 5,
    avatar: "https://randomuser.me/api/portraits/men/5.jpg",
    name: "",
    role: "-Event Organizer",
    review:
      "Theta knows how to throw a party! The vibes are always on point! 🕺 I can’t recommend it enough to my friends.",
  },
  {
    id: 6,
    avatar: "https://randomuser.me/api/portraits/women/6.jpg",
    name: "",
    role: "-Student",
    review:
      "The DJs are top-notch! They keep the energy high all night long! You’ll always leave wanting more.",
  },
  {
    id: 7,
    avatar: "https://randomuser.me/api/portraits/men/7.jpg",
    name: "",
    role: "-Workshop Participant",
    review:
      "Loved the hands-on approach in the workshops! Can't wait for more! It’s refreshing to learn in such an interactive environment.",
  },
  {
    id: 8,
    avatar: "https://randomuser.me/api/portraits/women/8.jpg",
    name: "",
    role: "-Student",
    review:
      "Every event is a blast! I'm always looking forward to what Theta has next! 🎊 Their events are unforgettable experiences.",
  },
];

export const event = {
  logo: "./Assets/logo2.png", 
  
};
export const AppAssets = {
  background: "Assets/bg/app.jpg",
  sizeChart: "/assets/size-chart.png",
 
};
